import React from "react";
import useRouting from "../../../../hooks/useRouting";
import useStore from "../../../../store/UseStore";
import { apiGateway } from "../../../../utils/config";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";

const MixedItemsUI = ({ data, onClickScrollToFreeSeries }) => {
  const {
    setOpenAllCategories,
    setAllCategoriesListing,
    setAllCategoriesLoading,
  } = useStore();
  const { routeToCategory } = useRouting();
  const axiosPrivate = useAxiosPrivate();

  const handleGetAllCategories = async () => {
    try {
      setAllCategoriesLoading(true);
      const url = `${apiGateway}/api/v1/home/mixed-items/`;
      const response = await axiosPrivate.get(url);
      if (response?.data) {
        setTimeout(() => {
          setAllCategoriesLoading(false);
          setAllCategoriesListing(response?.data?.mixed_items);
        }, 300);
      }
    } catch (error) {
      setAllCategoriesListing(false);
      console.log(error);
    }
  };

  const handleRedirectToCategory = ({ slug }) => {
    if (slug === "free_series") {
      onClickScrollToFreeSeries();
    } else if (slug === "view_all") {
      setOpenAllCategories(true);
      handleGetAllCategories();
    } else {
      routeToCategory({ slug });
    }
  };

  return (
    <div className="text-white grid grid-cols-4 py-4 mx-auto gap-y-8 w-[95%] md:hidden md:gap-y-12 md:mt-12 lg:mt-20">
      {data?.map((ele) => {
        return (
          <div
            className="mx-auto cursor-pointer"
            onClick={() => handleRedirectToCategory({ slug: ele?.slug })}
            key={ele?.title}
          >
            <img
              src={ele?.home_icon}
              alt={ele.title}
              className="w-[45px] h-[45px] mx-auto md:w-[60px] md:h-[60px] lg:w-[80px] lg:h-[80px]"
            />
            <h6
              className="text-[11px] !mt-2 text-center text-gray-400 lg:text-[13px] lg:!mt-4"
              style={{ fontFamily: "Inter" }}
            >
              {ele?.title}
            </h6>
          </div>
        );
      })}
    </div>
  );
};

export default MixedItemsUI;
